// extracted by mini-css-extract-plugin
module.exports = {"consBox":"hyZoY","consBoxHead":"XjkQs","conBoxInfoText":"XkqAS","conBoxTitle":"nTnr6"};